import React, { useRef } from 'react';
import { imageZone } from '../ZonesList/ZonesList.types';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { translatePercentCropToPixel, translateZoneToPixel } from '../zoneHelpers';

interface ZonePreviewProps {
  className?: string;
  style?: CSSProperties;
  wholeImageData: Blob;
  zone: imageZone;
  canvasWidth: number;
  title?: string;
  onClick: () => void;
}

const ZonePreview: React.FC<ZonePreviewProps> = ({
  className,
  style,
  wholeImageData,
  zone,
  canvasWidth,
  onClick,
  title,
}) => {
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);

  const draw = (ctx: CanvasRenderingContext2D) => {
    if (ctx) {
      const img = new Image();
      img.onload = function () {
        const scale = canvasWidth / img.naturalWidth;
        const pixelCrop = translateZoneToPixel(img.width, img.height, zone);
        if (previewCanvasRef && previewCanvasRef.current) {
          previewCanvasRef.current.width = Math.floor(pixelCrop.width * scale);
          previewCanvasRef.current.height = Math.floor(pixelCrop.height * scale);
          ctx.imageSmoothingQuality = 'high';
          ctx.save();
          ctx.scale(scale, scale);
          ctx.translate(-pixelCrop.x, -pixelCrop.y);
          ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.naturalWidth, img.naturalHeight);
          ctx.restore();
        }
      };
      img.src = URL.createObjectURL(wholeImageData);
    }
  };

  React.useEffect(() => {
    const ctx = previewCanvasRef?.current?.getContext('2d');
    if (ctx) {
      draw(ctx);
    }
  }, []);

  return <canvas ref={previewCanvasRef} className={className} style={style} onClick={onClick} title={title} />;
};

export default ZonePreview;
